<script lang="ts">
  import type { BaseProps } from "#lib/internal/types"
  import { cn } from "#lib/utils"
  import { ChevronDown, Locked } from "@tastyworks/icons-2.0"
  import { getSelectRootContext } from "./SelectRoot.svelte"

  type Props = BaseProps<"svg"> & {
    class?: string
  }

  let { class: className = "", ...restProps }: Props = $props()

  const rootCtx = getSelectRootContext()
</script>

{#if rootCtx.displayDisabledIcon && rootCtx.disabled}
  <Locked
    class={cn("transition-color w-5 text-icon-general-secondary", className)}
  />
{:else}
  <div
    class="flex h-full items-center"
    onpointerup={(event) => {
      event.stopPropagation()
      event.preventDefault()
      rootCtx.toggleDialog()
    }}
    aria-hidden="true"
  >
    <ChevronDown
      class={cn(
        "transition-color w-5 text-icon-general-secondary group-data-[open=true]:rotate-180 group-data-[disabled=true]:text-icon-general-disabled group-data-[open=true]:text-icon-general-primary",
        className
      )}
      id="{rootCtx.idPrefix}-indicator"
      {...restProps}
    />
  </div>
{/if}
